import { memo } from 'react';

function CircleFilledIcon({ color }: { color: string }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="25" fill="none" viewBox="0 0 24 25">
      <path
        fill={color}
        fillRule="evenodd"
        d="M22 12.5c0 5.523-4.477 10-10 10s-10-4.477-10-10 4.477-10 10-10 10 4.477 10 10zM8.97 9.47a.75.75 0 011.06 0L12 11.44l1.97-1.97a.75.75 0 011.06 1.06l-1.97 1.97 1.97 1.97a.75.75 0 01-1.06 1.06L12 13.56l-1.97 1.97a.75.75 0 01-1.06-1.06l1.97-1.97-1.97-1.97a.75.75 0 010-1.06z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default memo(CircleFilledIcon);
